import styled from 'styled-components'
import tokens from '../tokens'

const { fonts, colors } = tokens

export const Style = styled.div`
  .container-service-content {
    margin-top: 50px;
  }
  .title-service-content {
    font-family: ${fonts.fontFamilyBasic};
    font-size: 18px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.21;
    letter-spacing: 0.31px;
    display: ${props => props.display || 'unset'};
    color: ${colors['ui-ash-black']};
    text-align: ${props => props.align || 'unset'};
  }
  .subtitle-service-content {
    margin-top: 15px;
    margin-bottom: 15px;
    font-family: ${fonts.fontFamilyBasic};
    line-height: 24px;
    font-size: 14px;
    font-weight: ${props => props['fontWeight'] || 'regular'};
    font-style: normal;
    font-stretch: normal;
    letter-spacing: 0.18px;
    color: #333333;
    text-align: ${props => props.align || 'unset'};
  }
  .detail-content {
    margin-top: 30px;
  }
  .container-read-more {
    cursor: pointer;
    display: flex;
    flex-direction: row;
    align-item: center;
  }
  .read-more-text {
    margin-top: 15px;
    margin-bottom: 15px;
    margin-right: 10px;
    font-family: ${fonts.fontFamilyBasic};
    line-height: 24px;
    font-size: 14px;
    font-weight: ${props => props['fontWeight'] || 'regular'};
    font-style: normal;
    font-stretch: normal;
    letter-spacing: 0.18px;
    color: #ff7417;
    text-align: ${props => props.align || 'unset'};
  }
  .icon-service-content {
    display: block;
    padding: 0;
    width: 100%;
  }
  .container-image-service-content {
    display: flex;
    flex-direction: row;
    margin-top: 20px;
    justify-content: center;
  }
  .detail-content-link {
    margin-top: 30px;
    display: flex;
    flex-direction: column;
  }
  .link {
    color: #333333;
    text-decoration: underline;
  }
  .p-link {
    flex-wrap: wrap;
  }
`
